module.exports = __webpack_public_path__ + "static/chiclogo.b74ad1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chiclogo.png
// module id = 343
// module chunks = 15120005360602 35783957827783